module.exports = __webpack_public_path__ + "static/media/fvs_valve1_78.f5179440.jpg";